.root {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 2rem;
  color: hsl(var(--muted-foreground));
  text-align: center;
}

.icon {
  width: 3.5rem;
  height: 3.5rem;
}

.text {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
